import { NgModule } from '@angular/core';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { cache } from './cache';
import { createLink } from './link';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { ConfigService } from '../services/config/config.service';
import { APP_CONFIG } from '../services/config/constants';

@NgModule({
    imports: [HttpLinkModule],
    providers: [
        {
            provide: APOLLO_OPTIONS,
            useFactory: (httpLink: HttpLink, configService: ConfigService) => {
                return {
                    cache,
                    link: createLink(httpLink, configService),
                    defaultOptions: {
                        watchQuery: {
                            errorPolicy: 'all',
                        },
                        query: {
                            errorPolicy: 'all',
                        },
                        mutation: {
                            errorPolicy: 'all',
                        },
                        mutate: {
                            errorPolicy: 'all',
                        },
                        subscription: {
                            errorPolicy: 'all',
                        },
                    },
                };
            },
            deps: [HttpLink, ConfigService, APP_CONFIG],
        },
    ],
})
export class GraphQLModule {}
